<template>
  <div class="container">
    <h1>
      404 Not Found
    </h1>
    <h2>
      요청하신 페이지를 찾을 수 없습니다 :(
    </h2>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.container {
  font-family: 'TmonMonsori';
  h1 {
    font-size: 30px;
    line-height: 1;
  }
  h2 {
    margin-top: 10px;
    font-size: 40px;
    color: $primary;
  }
}</style>